import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withCtx as _withCtx } from "vue"
import _imports_0 from '../../assets/Images/icono-realtor.png'


const _hoisted_1 = { class: "text-left no-printable" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "tw-flex tw-h-[3px] tw-mt-4 tw-w-full tw-bg-[#b4b4b4]"
}
const _hoisted_4 = { class: "tw-px-[5em] tw-mt-4 tw-mb-[50px]" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "btn-list-users tw-flex tw-justify-end tw-mb-4" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn tw-flex tw-items-center tw-text-[#FFFFFF] tw-bg-[#00A0DA] tw-rounded-full",
    "data-bs-toggle": "modal",
    "data-bs-target": "#exampleModalUsers"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users tw-text-[#FFFFFF] tw-text-[30px] tw-pr-3" }),
    /*#__PURE__*/_createTextVNode(" SEE ECONOMIC SHEET ")
  ])
], -1)
const _hoisted_6 = {
  class: "modal fade modal-xl",
  id: "exampleModalUsers",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "modal-dialog" }
const _hoisted_8 = { class: "modal-content" }
const _hoisted_9 = { class: "modal-header" }
const _hoisted_10 = {
  key: 0,
  class: "comment-box"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "\"Action.\"", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "\"Watch Scenario.\"", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close custom-close-button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
], -1)
const _hoisted_15 = { class: "modal-body" }
const _hoisted_16 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_17 = { class: "tw-flex tw-gap-3" }
const _hoisted_18 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Name", -1)
const _hoisted_20 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PhoneNumber", -1)
const _hoisted_22 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Date", -1)
const _hoisted_24 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PHONE NUMBER"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CREATION DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ACTION")
  ])
], -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "5",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  class: "modal fade modal-xl",
  id: "exampleModal4858",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel4858",
  "aria-hidden": "true"
}
const _hoisted_34 = { class: "modal-dialog" }
const _hoisted_35 = { class: "modal-content" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_37 = { class: "modal-body" }
const _hoisted_38 = { class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-" }
const _hoisted_39 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_40 = { class: "tw-flex tw-justify-start gap-3 tw-w-full" }
const _hoisted_41 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_42 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CODE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SECTION"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCENARIO"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "WATCH SCENARIO")
  ])
], -1)
const _hoisted_44 = { key: 0 }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { key: 1 }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "4",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { class: "tw-bg-white tw-rounded-xl tw-p-4" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-text-center tw-text-lg tw-text-[20px] tw-border-b-[2px] tw-border-[#b0b0b0] tw-pb-2" }, " CASH PASSIVE INVESTMENT", -1)
const _hoisted_53 = { class: "tw-flex tw-justify-between tw-items-center tw-gap-5 tw-mt-3" }
const _hoisted_54 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExample3",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("b", null, "TITLE COMPANY     ▼")
], -1)
const _hoisted_56 = {
  class: "collapse",
  id: "collapseExample3"
}
const _hoisted_57 = { class: "card card-body tw-px-[80px]" }
const _hoisted_58 = {
  class: "tw-px-[30px]",
  style: {"border":"1px solid #b0b0b0"}
}
const _hoisted_59 = { class: "tw-flex tw-justify-around mt-3 mb-3" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_61 = { class: "pb-3" }
const _hoisted_62 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "CLOSING CLOSE"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "OTHER PRICE")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "1"
    }, "BUYER"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "1"
    }, "SELLER"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "1"
    }, [
      /*#__PURE__*/_createTextVNode("SEARCH TITLE "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" COMPANY")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "1"
    }, "CHAIN TITTLE")
  ])
], -1)
const _hoisted_64 = {
  key: 0,
  class: "data"
}
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExample4",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("b", null, "INSPECTOR     ▼")
], -1)
const _hoisted_68 = {
  class: "collapse",
  id: "collapseExample4"
}
const _hoisted_69 = { class: "card card-body" }
const _hoisted_70 = { class: "tw-flex tw-justify-around" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("button", { class: "tw-bg-[#00a0da] tw-px-11 tw-mt-2 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]" }, "GET IT", -1)
const _hoisted_73 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, "CUSTOMER INFORMATION ", -1)
const _hoisted_75 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_76 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5" }
const _hoisted_77 = { class: "tw-w-full" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "NAME", -1)
const _hoisted_79 = { class: "tw-w-full" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PHONE NUMBER", -1)
const _hoisted_81 = { class: "tw-w-full" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "EMAIL", -1)
const _hoisted_83 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, "PROPERTY INFORMATION ", -1)
const _hoisted_85 = { class: "tw-px-4" }
const _hoisted_86 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_87 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY PRICE ", -1)
const _hoisted_89 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_90 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " TYPE OF PROPERTY ", -1)
const _hoisted_92 = {
  key: 0,
  class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3"
}
const _hoisted_93 = { class: "tw-flex tw-justify-between tw-items-center tw-gap-10" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select", -1)
const _hoisted_95 = ["value"]
const _hoisted_96 = ["value"]
const _hoisted_97 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY ADDRESSES ", -1)
const _hoisted_99 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_100 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PASSIVE # ", -1)
const _hoisted_102 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_103 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " CLOSING COST ", -1)
const _hoisted_105 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_106 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, "TAXES, INSURANCE AND ASSOCIATION ", -1)
const _hoisted_108 = { class: "tw-px-4" }
const _hoisted_109 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_110 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ANNUAL PROPERTY TAXES ", -1)
const _hoisted_112 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_113 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MONTHLY PROPERTY TAXES ", -1)
const _hoisted_115 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_116 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ANNUAL PROPERTY INSURANCE ", -1)
const _hoisted_118 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_119 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MONTHLY PROPERTY INSURANCE ", -1)
const _hoisted_121 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_122 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ANNUAL FLOOD INSURANCE ", -1)
const _hoisted_124 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_125 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MONTHLY FLOOD INSURANCE ", -1)
const _hoisted_127 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_128 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ANNUAL FEDERAL TAXES ", -1)
const _hoisted_130 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_131 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MONTHLY FEDERAL TAXES ", -1)
const _hoisted_133 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_134 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ASSOCIATION PAYMENT ", -1)
const _hoisted_136 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_137 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " BROKER PAYMENT ", -1)
const _hoisted_139 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_140 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " OTHER MONTHLY PAYMENT ", -1)
const _hoisted_142 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_143 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, "INCOME ", -1)
const _hoisted_145 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_146 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5" }
const _hoisted_147 = { class: "tw-w-full" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "ESTIMATE PROPERTY RENT", -1)
const _hoisted_149 = { class: "tw-w-full" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "ESTIMATE CAPITAL GAIN OR PLUSVALIA", -1)
const _hoisted_151 = ["value"]
const _hoisted_152 = { class: "tw-flex tw-items-center tw-justify-center tw-mt-10 tw-gap-5 tw-text-left tw-mb-8" }
const _hoisted_153 = { class: "tw-flex tw-justify-center tw-gap-[20px] tw-pb-5" }
const _hoisted_154 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-mt-4 tw-px-14" }
const _hoisted_155 = { class: "tw-flex tw-justify-end" }
const _hoisted_156 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, "TOTAL INVESTMENT ", -1)
const _hoisted_158 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-mt-4 tw-px-14" }
const _hoisted_159 = { class: "tw-flex tw-justify-end" }
const _hoisted_160 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, "AVERAGE NET PROFIT 5 YEARS (%) ", -1)
const _hoisted_162 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-w-full" }
const _hoisted_163 = ["disabled"]
const _hoisted_164 = {
  class: "modal fade modal-xl",
  id: "exampleModalEscenarioPasiveCash",
  tabindex: "-1",
  "aria-labelledby": "exampleModalEscenarioPasiveCash",
  "aria-hidden": "true"
}
const _hoisted_165 = { class: "modal-dialog" }
const _hoisted_166 = { class: "modal-content" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_168 = { class: "modal-body" }
const _hoisted_169 = { class: "tw-flex tw-justify-end tw-gap-[40px] tw-pr-7" }
const _hoisted_170 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print tw-text-[#FFFFFF] tw-pr-2" }, null, -1)
const _hoisted_172 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_173 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope tw-text-[#FFFFFF] tw-text-[18px] tw-pr-2" }, null, -1)
const _hoisted_174 = /*#__PURE__*/_createElementVNode("section", { slot: "pdf-content" }, null, -1)
const _hoisted_175 = {
  class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-",
  id: "printable-target"
}
const _hoisted_176 = /*#__PURE__*/_createElementVNode("h1", { class: "pb-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("PASSIVE CASH"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" PROFIT OF ESTIMATED COST/BENEFITS")
  ])
], -1)
const _hoisted_177 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_178 = {
  key: 0,
  class: "tw-flex tw-justify-start gap-3 tw-w-full"
}
const _hoisted_179 = { class: "table-mlo w-100 bg-white rounded-4" }
const _hoisted_180 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_181 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "CUSTOMER INFORMATION")
  ])
], -1)
const _hoisted_182 = { class: "data" }
const _hoisted_183 = /*#__PURE__*/_createElementVNode("td", null, "NAME", -1)
const _hoisted_184 = { class: "data" }
const _hoisted_185 = /*#__PURE__*/_createElementVNode("td", null, "PHONE-NUMBER", -1)
const _hoisted_186 = { class: "data" }
const _hoisted_187 = /*#__PURE__*/_createElementVNode("td", null, "EMAIL", -1)
const _hoisted_188 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "PROPERTY INFORMATION")
  ])
], -1)
const _hoisted_190 = { class: "data" }
const _hoisted_191 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-PRICE", -1)
const _hoisted_192 = { class: "data" }
const _hoisted_193 = /*#__PURE__*/_createElementVNode("td", null, "TYPE-OF-PROPERTY", -1)
const _hoisted_194 = { class: "data" }
const _hoisted_195 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY ADDRESSES", -1)
const _hoisted_196 = { class: "data" }
const _hoisted_197 = /*#__PURE__*/_createElementVNode("td", null, "PASSIVE #", -1)
const _hoisted_198 = { class: "data" }
const _hoisted_199 = /*#__PURE__*/_createElementVNode("td", null, "CLOSING-COST", -1)
const _hoisted_200 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_201 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "TAXES, INSURANCE AND ASSOCIATION")
  ])
], -1)
const _hoisted_202 = { class: "data" }
const _hoisted_203 = /*#__PURE__*/_createElementVNode("td", null, "ANNUAL-PROPERTY-TAXES", -1)
const _hoisted_204 = { class: "data" }
const _hoisted_205 = /*#__PURE__*/_createElementVNode("td", null, "MONTHLY-PROPERTY-TAXES", -1)
const _hoisted_206 = { class: "data" }
const _hoisted_207 = /*#__PURE__*/_createElementVNode("td", null, "ANNUAL-PROPERTY-INSURANCE", -1)
const _hoisted_208 = { class: "data" }
const _hoisted_209 = /*#__PURE__*/_createElementVNode("td", null, "MONTHLY-PROPERTY-INSURANCE", -1)
const _hoisted_210 = { class: "data" }
const _hoisted_211 = /*#__PURE__*/_createElementVNode("td", null, "ANNUAL-FLOOD-INSURANCE", -1)
const _hoisted_212 = { class: "data" }
const _hoisted_213 = /*#__PURE__*/_createElementVNode("td", null, "MONTHLY-FLOOD-INSURANCE", -1)
const _hoisted_214 = { class: "data" }
const _hoisted_215 = /*#__PURE__*/_createElementVNode("td", null, "ASSOCIATION-PAYMENT", -1)
const _hoisted_216 = { class: "data" }
const _hoisted_217 = /*#__PURE__*/_createElementVNode("td", null, "BROKER-PAYMENT", -1)
const _hoisted_218 = { class: "data" }
const _hoisted_219 = /*#__PURE__*/_createElementVNode("td", null, "OTHERS-MONTHLY-PAYMENT", -1)
const _hoisted_220 = { class: "table table-bordered border-0 mb-0 table-edit table-no-radius" }
const _hoisted_221 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "INCOME")
  ])
], -1)
const _hoisted_222 = /*#__PURE__*/_createElementVNode("td", null, "ANNUAL-NET-PROFIT(%)", -1)
const _hoisted_223 = /*#__PURE__*/_createElementVNode("td", null, "NET PROFIT 5 YEARS(%)", -1)
const _hoisted_224 = /*#__PURE__*/_createElementVNode("div", { class: "px-5 pb-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tw-font-medium tw-text-[18px]" }, "Note:"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" The investment outcome presented here is an estimate subject to potential "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" fluctuations arising from the execution of the project. ")
  ])
], -1)
const _hoisted_225 = {
  class: "modal fade",
  id: "exampleModalMessage",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_226 = { class: "modal-dialog" }
const _hoisted_227 = { class: "content-mensage modal-content tw-bg-[#E6E7E8]" }
const _hoisted_228 = /*#__PURE__*/_createElementVNode("div", { class: "boton-mensage modal-header tw-flex tw-items-center tw-outline-none tw-bg-[#00a0da] tw-border-[#00a0da] tw-bordered-[20px]" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title tw-text-white tw-text-xl",
    id: "exampleModalLabel"
  }, "New Message"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle tw-text-[25px] tw-text-white" })
  ])
], -1)
const _hoisted_229 = { class: "modal-body" }
const _hoisted_230 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_231 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "USER-EMAIL: ", -1)
const _hoisted_232 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_233 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "SUBJECT: ", -1)
const _hoisted_234 = { class: "tw-mt-5 tw-w-full tw-flex tw-justify-center tw-items-center" }
const _hoisted_235 = /*#__PURE__*/_createElementVNode("div", { class: "tw-pl-5" }, null, -1)
const _hoisted_236 = { class: "modal-footer tw-flex tw-items-center tw-justify-between" }
const _hoisted_237 = { class: "tw-flex tw-justify-start tw-items-center" }
const _hoisted_238 = {
  key: 0,
  class: "btn-attach tw-bg-[#E6E7E8] tw-h-[40px] tw-font-bold tw-px-4 tw-rounded-full tw-text-xl"
}
const _hoisted_239 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip tw-text-gray-500" }, null, -1)
const _hoisted_240 = { class: "tw-flex tw-justify-end tw-items-center" }
const _hoisted_241 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_ResidentialView = _resolveComponent("ResidentialView")!
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_VueNumberFormat = _resolveComponent("VueNumberFormat")!
  const _component_vue3_html2pdf = _resolveComponent("vue3-html2pdf")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.loaderConfig.isLoading,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loaderConfig.isLoading) = $event)),
        "can-cancel": false,
        loader: 'dots',
        "is-full-page": !_ctx.loaderConfig.fullPage
      }, null, 8, ["active", "is-full-page"]),
      _createVNode(_component_TopBar, {
        helpBar: true,
        helpDescription: "Video tutorial for the use of the ''PASIVE CASH''",
        helpVideo: "https://www.realtortools.org/media/Video%20Passive%20Cash.mp4"
      }),
      (!_ctx.foreign)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_ResidentialView, {
              header: false,
              onRealtorEvent: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeRealtor($event)))
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.foreign)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    id: "openNoteModal1",
                    class: "btn tw-bg-[#FF0000] tw-text-[#FFFFFF] tw-rounded-lg fw-bold btn-sm",
                    style: {"border":"none"},
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleComment && _ctx.toggleComment(...args)))
                  }, " SEE NOTE "),
                  (_ctx.isCommentVisible)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createTextVNode(" You can find the Economic Sheet by: Name, Phone Number, or Date."),
                        _hoisted_11,
                        _createTextVNode("Then, to filter, click on "),
                        _hoisted_12,
                        _createTextVNode(" On the new screen, click on "),
                        _hoisted_13
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_14
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_ctx.scenario.users)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _withDirectives(_createElementVNode("input", {
                            name: "",
                            id: "",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.scenario.users.name) = $event)),
                            class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                          }, null, 512), [
                            [_vModelText, _ctx.params.scenario.users.name]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _withDirectives(_createElementVNode("input", {
                            name: "",
                            id: "",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.scenario.users.phonenumber) = $event)),
                            class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                          }, null, 512), [
                            [_vModelText, _ctx.params.scenario.users.phonenumber]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode(_component_datepicker, {
                            "auto-apply": "",
                            class: "w-100",
                            range: "",
                            modelValue: _ctx.configDatePicker.date,
                            "onUpdate:modelValue": [
                              _cache[5] || (_cache[5] = ($event: any) => ((_ctx.configDatePicker.date) = $event)),
                              _ctx.changeDate
                            ],
                            placeholder: "Enter date range..."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getScenarioUsers())),
                        class: "mb-3 tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[150px] tw-rounded-full tw-text-[18px]"
                      }, "Filter"),
                      _createElementVNode("table", _hoisted_24, [
                        _hoisted_25,
                        (_ctx.scenario.users.results && _ctx.scenario.users.results.length > 0)
                          ? (_openBlock(), _createElementBlock("tbody", _hoisted_26, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.users.results, (user) => {
                                return (_openBlock(), _createElementBlock("tr", null, [
                                  _createElementVNode("td", null, _toDisplayString(user.user_name), 1),
                                  _createElementVNode("td", null, _toDisplayString(user.user_email), 1),
                                  _createElementVNode("td", null, _toDisplayString(user.user_phonenumber), 1),
                                  _createElementVNode("td", null, _toDisplayString(user.create_date), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("a", {
                                      "data-bs-toggle": "modal",
                                      "data-bs-target": "#exampleModal4858",
                                      href: "#",
                                      onClick: ($event: any) => (_ctx.loadScenarios(user))
                                    }, _hoisted_29, 8, _hoisted_27)
                                  ])
                                ]))
                              }), 256))
                            ]))
                          : (_openBlock(), _createElementBlock("tbody", _hoisted_30, _hoisted_32))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      (_ctx.scenario.userScenarios && _ctx.scenario.userScenarios.results)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("table", _hoisted_42, [
                              _hoisted_43,
                              (_ctx.scenario.userScenarios.results && _ctx.scenario.userScenarios.results.length > 0)
                                ? (_openBlock(), _createElementBlock("tbody", _hoisted_44, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.userScenarios.results, (userscenario) => {
                                      return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", null, _toDisplayString(userscenario.code), 1),
                                        _createElementVNode("td", null, _toDisplayString(userscenario.date), 1),
                                        _createElementVNode("td", null, _toDisplayString(userscenario.type), 1),
                                        _createElementVNode("td", null, _toDisplayString(userscenario.type_name), 1),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("a", {
                                            "data-bs-toggle": "modal",
                                            "data-bs-target": "#exampleModalEscenarioPasiveCash",
                                            href: "#",
                                            onClick: ($event: any) => (_ctx.loadScenario(userscenario))
                                          }, _hoisted_47, 8, _hoisted_45)
                                        ])
                                      ]))
                                    }), 256))
                                  ]))
                                : (_openBlock(), _createElementBlock("tbody", _hoisted_48, _hoisted_50))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _createElementVNode("div", _hoisted_56, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTitleCompanies, (user) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", null, _toDisplayString(user.companyname), 1),
                          _createTextVNode(),
                          _hoisted_60
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("table", _hoisted_62, [
                          _hoisted_63,
                          _createElementVNode("tbody", null, [
                            (user.tables[0] !== undefined)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_64, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.tables[0].tabledata[0].data, (tabledata) => {
                                    return (_openBlock(), _createElementBlock("td", null, _toDisplayString(tabledata.table_closing_close) + "%", 1))
                                  }), 256)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.tables[0].tabledata[1].data, (tabledata) => {
                                    return (_openBlock(), _createElementBlock("td", null, _toDisplayString(tabledata.table_each_tittle_review), 1))
                                  }), 256))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("button", {
                          class: "tw-bg-[#00a0da] tw-px-11 tw-mt-4 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]",
                          onClick: ($event: any) => (_ctx.getItTitleCompany(user))
                        }, "GET IT", 8, _hoisted_65)
                      ])
                    ])
                  ]))
                }), 256))
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _hoisted_67,
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listInspectors, (user) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        _createElementVNode("span", null, _toDisplayString(user.username + " " + user.lastname), 1),
                        _createTextVNode(),
                        _hoisted_71,
                        _hoisted_72
                      ]))
                    }), 256))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_73, [
            _hoisted_74,
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _hoisted_78,
                  _withDirectives(_createElementVNode("input", {
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.customer.name) = $event)),
                    placeholder: "Complete name",
                    class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                  }, null, 512), [
                    [_vModelText, _ctx.customer.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _hoisted_80,
                  _withDirectives(_createElementVNode("input", {
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.customer.phone) = $event)),
                    placeholder: "9999999999",
                    class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                  }, null, 512), [
                    [_vModelText, _ctx.customer.phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_81, [
                  _hoisted_82,
                  _withDirectives(_createElementVNode("input", {
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.customer.email) = $event)),
                    placeholder: "example@gmail.com",
                    class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                  }, null, 512), [
                    [_vModelText, _ctx.customer.email]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_83, [
            _hoisted_84,
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("table", _hoisted_86, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_87, [
                    _hoisted_88,
                    _createElementVNode("td", _hoisted_89, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyPrice",
                        value: _ctx.passiveCash.propertyPrice,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.passiveCash.propertyPrice) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_90, [
                    _hoisted_91,
                    (_ctx.listPropertyTypes.length > 0)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_92, [
                          _createElementVNode("div", _hoisted_93, [
                            _withDirectives(_createElementVNode("select", {
                              name: "",
                              id: "",
                              class: "form-control tw-full",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.passiveCash.propertyType) = $event)),
                              onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.calculatePropertyEstimateCapitalGain && _ctx.calculatePropertyEstimateCapitalGain(...args)))
                            }, [
                              _hoisted_94,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPropertyTypes, (property) => {
                                return (_openBlock(), _createElementBlock("option", { value: property }, _toDisplayString(property.name), 9, _hoisted_95))
                              }), 256))
                            ], 544), [
                              [_vModelSelect, _ctx.passiveCash.propertyType]
                            ]),
                            (_ctx.passiveCash.propertyType)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  type: "text",
                                  value: (_ctx.passiveCash.propertyType.text ? _ctx.passiveCash.propertyType.text + '%' : ''),
                                  disabled: ""
                                }, null, 8, _hoisted_96))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("tr", _hoisted_97, [
                    _hoisted_98,
                    _createElementVNode("td", _hoisted_99, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.passiveCash.propertyAddress) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.passiveCash.propertyAddress]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_100, [
                    _hoisted_101,
                    _createElementVNode("td", _hoisted_102, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.passiveCash.propertyPassiveNumber) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.passiveCash.propertyPassiveNumber]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_103, [
                    _hoisted_104,
                    _createElementVNode("td", _hoisted_105, _toDisplayString(_ctx.passiveCash.propertyClosingCostBuy?.text !== undefined
                                            ? '$' + _ctx.commaFormat(_ctx.passiveCash.propertyClosingCostBuy?.text)
                                            : ''), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_106, [
            _hoisted_107,
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("table", _hoisted_109, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_110, [
                    _hoisted_111,
                    _createElementVNode("td", _hoisted_112, [
                      _createElementVNode("div", {
                        onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.calculateProperty('monthlytaxes')))
                      }, [
                        _createVNode(_component_VueNumberFormat, {
                          id: "propertyAnnualPropertyTaxes",
                          value: _ctx.passiveCash.propertyAnnualPropertyTaxes,
                          "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.passiveCash.propertyAnnualPropertyTaxes) = $event)),
                          options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                        }, null, 8, ["value", "options"])
                      ], 32)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_113, [
                    _hoisted_114,
                    _createElementVNode("td", _hoisted_115, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyMonthlyPropertyTaxes",
                        value: _ctx.passiveCash.propertyMonthlyPropertyTaxes,
                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.passiveCash.propertyMonthlyPropertyTaxes) = $event)),
                        disabled: "",
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_116, [
                    _hoisted_117,
                    _createElementVNode("td", _hoisted_118, [
                      _createElementVNode("div", {
                        onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.calculateProperty('estimated')))
                      }, [
                        _createVNode(_component_VueNumberFormat, {
                          id: "propertyAnnualPropertyInsurance",
                          value: _ctx.passiveCash.propertyAnnualPropertyInsurance,
                          "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.passiveCash.propertyAnnualPropertyInsurance) = $event)),
                          options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                        }, null, 8, ["value", "options"])
                      ], 32)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_119, [
                    _hoisted_120,
                    _createElementVNode("td", _hoisted_121, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyMonthlyPropertyInsurance",
                        value: _ctx.passiveCash.propertyMonthlyPropertyInsurance,
                        "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.passiveCash.propertyMonthlyPropertyInsurance) = $event)),
                        disabled: "",
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_122, [
                    _hoisted_123,
                    _createElementVNode("td", _hoisted_124, [
                      _createElementVNode("div", {
                        onInput: _cache[22] || (_cache[22] = ($event: any) => (_ctx.calculateProperty('monthlystatetaxes')))
                      }, [
                        _createVNode(_component_VueNumberFormat, {
                          id: "propertyAnnualStateTaxes",
                          value: _ctx.passiveCash.propertyAnnualStateTaxes,
                          "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.passiveCash.propertyAnnualStateTaxes) = $event)),
                          options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                        }, null, 8, ["value", "options"])
                      ], 32)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_125, [
                    _hoisted_126,
                    _createElementVNode("td", _hoisted_127, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyBrokerPayment",
                        value: _ctx.passiveCash.propertyMonthlyStateTaxes,
                        "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.passiveCash.propertyMonthlyStateTaxes) = $event)),
                        disabled: "",
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_128, [
                    _hoisted_129,
                    _createElementVNode("td", _hoisted_130, [
                      _createElementVNode("div", {
                        onInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.calculateProperty('monthlyfederaltaxes')))
                      }, [
                        _createVNode(_component_VueNumberFormat, {
                          id: "propertyAnnualFederalTaxes",
                          value: _ctx.passiveCash.propertyAnnualFederalTaxes,
                          "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.passiveCash.propertyAnnualFederalTaxes) = $event)),
                          options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                        }, null, 8, ["value", "options"])
                      ], 32)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_131, [
                    _hoisted_132,
                    _createElementVNode("td", _hoisted_133, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyBrokerPayment",
                        value: _ctx.passiveCash.propertyMonthlyFederalTaxes,
                        "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.passiveCash.propertyMonthlyFederalTaxes) = $event)),
                        disabled: "",
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_134, [
                    _hoisted_135,
                    _createElementVNode("td", _hoisted_136, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyAssociationPaymentTax",
                        value: _ctx.passiveCash.propertyAssociationPaymentTax,
                        "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.passiveCash.propertyAssociationPaymentTax) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_137, [
                    _hoisted_138,
                    _createElementVNode("td", _hoisted_139, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyBrokerPayment",
                        value: _ctx.passiveCash.propertyBrokerPayment,
                        "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.passiveCash.propertyBrokerPayment) = $event)),
                        disabled: "",
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_140, [
                    _hoisted_141,
                    _createElementVNode("td", _hoisted_142, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyOtherMonthlyPayment",
                        value: _ctx.passiveCash.propertyOtherMonthlyPayment,
                        "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.passiveCash.propertyOtherMonthlyPayment) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_143, [
            _hoisted_144,
            _createElementVNode("div", _hoisted_145, [
              _createElementVNode("div", _hoisted_146, [
                _createElementVNode("div", _hoisted_147, [
                  _hoisted_148,
                  _createVNode(_component_VueNumberFormat, {
                    id: "propertyEstimateRent",
                    class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5",
                    value: _ctx.passiveCash.propertyEstimateRent,
                    "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.passiveCash.propertyEstimateRent) = $event)),
                    options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                  }, null, 8, ["value", "options"])
                ]),
                _createElementVNode("div", _hoisted_149, [
                  _hoisted_150,
                  _createElementVNode("input", {
                    name: "",
                    type: "text",
                    disabled: "",
                    value: _ctx.passiveCash.propertyEstimateCapitalGain ? _ctx.passiveCash.propertyEstimateCapitalGain : '',
                    class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                  }, null, 8, _hoisted_151)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_152, [
            _createElementVNode("button", {
              onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.submitFormula('propertyTotalExample', $event))),
              class: "tw-bg-[#00a0da] tw-px-11 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[200px] disabled:tw-bg-[#cfcfcf] disabled:tw-text-white"
            }, "RUN")
          ]),
          _createElementVNode("div", _hoisted_153, [
            _createElementVNode("div", _hoisted_154, [
              _createElementVNode("div", _hoisted_155, [
                _createElementVNode("div", _hoisted_156, [
                  _hoisted_157,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.passiveCash.propertyAnnualNetProfit) = $event)),
                    class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                  }, null, 512), [
                    [_vModelText, _ctx.passiveCash.propertyAnnualNetProfit]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_158, [
              _createElementVNode("div", _hoisted_159, [
                _createElementVNode("div", _hoisted_160, [
                  _hoisted_161,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.passiveCash.propertyAverageNetProfitYears) = $event)),
                    class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                  }, null, 512), [
                    [_vModelText, _ctx.passiveCash.propertyAverageNetProfitYears]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_162, [
            _createElementVNode("button", {
              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.submitScenario($event))),
              disabled: !_ctx.scenarioValid,
              class: "tw-bg-[#78c18a] disabled:tw-bg-[#ccc] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
            }, "SAVE & REGISTER", 8, _hoisted_163)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_164, [
      _createElementVNode("div", _hoisted_165, [
        _createElementVNode("div", _hoisted_166, [
          _hoisted_167,
          _createElementVNode("div", _hoisted_168, [
            _createElementVNode("div", _hoisted_169, [
              _createElementVNode("div", _hoisted_170, [
                _createElementVNode("button", {
                  onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.printScenario())),
                  class: "block"
                }, [
                  _hoisted_171,
                  _createTextVNode("PRINT")
                ])
              ]),
              _createElementVNode("div", _hoisted_172, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.generateMail()))
                }, [
                  _hoisted_173,
                  _createTextVNode("SEND")
                ]),
                _createVNode(_component_vue3_html2pdf, {
                  "show-layout": false,
                  "float-layout": true,
                  "enable-download": false,
                  "preview-modal": false,
                  "pdf-quality": 2,
                  "pdf-format": "a4",
                  "pdf-content-width": "800px",
                  "manual-pagination": true,
                  onBeforeDownload: _cache[37] || (_cache[37] = ($event: any) => (_ctx.beforeFileGenerated($event))),
                  ref: "html2Pdf"
                }, {
                  default: _withCtx(() => [
                    _hoisted_174
                  ]),
                  _: 1
                }, 512)
              ])
            ]),
            _createElementVNode("div", _hoisted_175, [
              _hoisted_176,
              _createElementVNode("div", _hoisted_177, [
                (_ctx.scenario.scenarioData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                      _createElementVNode("div", _hoisted_179, [
                        _createElementVNode("table", _hoisted_180, [
                          _hoisted_181,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_182, [
                              _hoisted_183,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_184, [
                              _hoisted_185,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_phonenumber), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_186, [
                              _hoisted_187,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_email), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_188, [
                          _hoisted_189,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_190, [
                              _hoisted_191,
                              _createVNode(_component_VueNumberFormat, {
                                id: "propertyPrice",
                                value: _ctx.scenario.scenarioData.financial_information.propertyPrice,
                                "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.scenario.scenarioData.financial_information.propertyPrice) = $event)),
                                options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' },
                                onChange: _ctx.calculatePropertyEstimateCapitalGain
                              }, null, 8, ["value", "options", "onChange"])
                            ]),
                            _createElementVNode("tr", _hoisted_192, [
                              _hoisted_193,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyType.name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_194, [
                              _hoisted_195,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAddress), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_196, [
                              _hoisted_197,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyPassiveNumber), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_198, [
                              _hoisted_199,
                              _createVNode(_component_VueNumberFormat, {
                                id: "propertyPrice",
                                value: _ctx.scenario.scenarioData.financial_information.propertyClosingCostBuy,
                                "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.scenario.scenarioData.financial_information.propertyClosingCostBuy) = $event)),
                                options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                              }, null, 8, ["value", "options"])
                            ])
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_200, [
                          _hoisted_201,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_202, [
                              _hoisted_203,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAnnualPropertyTaxes), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_204, [
                              _hoisted_205,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyMonthlyPropertyTaxes), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_206, [
                              _hoisted_207,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAnnualPropertyInsurance), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_208, [
                              _hoisted_209,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyMonthlyPropertyInsurance), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_210, [
                              _hoisted_211,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAnnualStateTaxes), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_212, [
                              _hoisted_213,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyMonthlyStateTaxes), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_214, [
                              _hoisted_215,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAssociationPaymentTax), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_216, [
                              _hoisted_217,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyBrokerPayment), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_218, [
                              _hoisted_219,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyOtherMonthlyPayment), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_220, [
                          _hoisted_221,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _hoisted_222,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAnnualNetProfit), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_223,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAverageNetProfitYears), 1)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _hoisted_224
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_225, [
      _createElementVNode("div", _hoisted_226, [
        _createElementVNode("div", _hoisted_227, [
          _hoisted_228,
          _createElementVNode("div", _hoisted_229, [
            _createElementVNode("div", _hoisted_230, [
              _hoisted_231,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.scenarioMail.email) = $event)),
                class: "tw-w-full tw-h-[32px]",
                style: {"padding-left":"10px"}
              }, null, 512), [
                [_vModelText, _ctx.scenarioMail.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_232, [
              _hoisted_233,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.scenarioMail.subject) = $event)),
                class: "tw-w-full tw-h-[32px]",
                style: {"padding-left":"10px"}
              }, null, 512), [
                [_vModelText, _ctx.scenarioMail.subject]
              ])
            ]),
            _createElementVNode("div", _hoisted_234, [
              _withDirectives(_createElementVNode("textarea", {
                name: "",
                id: "",
                cols: "53",
                "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.scenarioMail.message) = $event)),
                rows: "9"
              }, null, 512), [
                [_vModelText, _ctx.scenarioMail.message]
              ])
            ])
          ]),
          _hoisted_235,
          _createElementVNode("div", _hoisted_236, [
            _createElementVNode("div", _hoisted_237, [
              (_ctx.scenarioMail.file)
                ? (_openBlock(), _createElementBlock("button", _hoisted_238, [
                    _hoisted_239,
                    _createTextVNode(" " + _toDisplayString(_ctx.scenarioMail.file.name), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_240, [
              _createElementVNode("button", {
                "data-bs-dismiss": "modal",
                class: "tw-bg-[#78c18a] disabled:tw-bg-[#cfcfcf] disabled:tw-text-white tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl",
                disabled: _ctx.v$.scenarioMail.$invalid,
                onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.sendScenarioMail && _ctx.sendScenarioMail(...args)))
              }, "SEND MESSAGE", 8, _hoisted_241)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}